module.exports = __webpack_public_path__ + "img/slide15.3588b40d.jpg";